"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AntiGravityTechnology = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var AntiGravityTechnology = (function (_super) {
    __extends(AntiGravityTechnology, _super);
    function AntiGravityTechnology() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ANTI_GRAVITY_TECHNOLOGY,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 14,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 7); }),
            cardDiscount: { amount: 2 },
            metadata: {
                description: 'Requires 7 science tags.',
                cardNumber: '150',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a card, you pay 2 M€ less for it.', function (be) { return be.empty().startEffect.megacredits(-2); });
                }),
                victoryPoints: 3,
            },
        }) || this;
    }
    AntiGravityTechnology.prototype.getCardDiscount = function () {
        return 2;
    };
    AntiGravityTechnology.prototype.play = function () {
        return undefined;
    };
    AntiGravityTechnology.prototype.getVictoryPoints = function () {
        return 3;
    };
    return AntiGravityTechnology;
}(Card_1.Card));
exports.AntiGravityTechnology = AntiGravityTechnology;
//# sourceMappingURL=AntiGravityTechnology.js.map